import { Box } from "@ecco/ui/box";
import type { SVGProps } from "react";
import React from "react";
import { styles } from "./EccoLoading.styles";

export const EccoLoading = (props: SVGProps<SVGSVGElement>) => {
    return (
        <Box
            position={"relative"}
            left={0}
            right={0}
            minH={"50vh"}
            w="full"
            display={"flex"}
            justifyContent="center"
            alignItems={"center"}
            sx={styles.loading}
        >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" className="svg" {...props}>
                <path
                    d="M18.5 16.7c-1.6 2-4.1 3.2-6.9 3.2-4.9 0-8.9-4-8.9-8.9s4-8.9 8.9-8.9 5.3 1.3 6.9 3.3L5.4 15.8"
                    className="path"
                />
            </svg>
        </Box>
    );
};
